import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import {Observable} from 'rxjs';
import {AuthService} from 'app/services/auth.service';
import {ThemingService} from '../../theming.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard   {
  constructor(
    private router: Router,
    private authService: AuthService,
    private themingService: ThemingService,
  ) { }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    if (!await this.authService.isLoggedIn()) {
      // not logged in so redirect to login page with the return url
      this.authService.redirectUrl = state.url;
      this.authService.startAuthentication();
      return false;
    }
    this.authService.tryToAuthorizeUser();
    // If logged in, load current client theme
    await this.themingService.loadClientTheme();

    return true;
  }
}
